"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  properties: {
    allow_multiple: {
      type: 'boolean'
    }
  }
};
exports.default = _default;